/**
 * DevPage
 * This is DevPage API contract
 *
 * OpenAPI spec version: 1.1.0
 * Contact: apiteam@swagger.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorResponse } from '../model/errorResponse';
import { Server } from '../model/server';
import { ServerDetails } from '../model/serverDetails';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class ServersService {

    protected basePath = 'http://localhost:8090';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param server Server objects that needs to be added
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addServer(server: Server, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public addServer(server: Server, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public addServer(server: Server, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public addServer(server: Server, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (server === null || server === undefined) {
            throw new Error('Required parameter server was null or undefined when calling addServer.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/servers`,
            server,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serverId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteServer(serverId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteServer(serverId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteServer(serverId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteServer(serverId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (serverId === null || serverId === undefined) {
            throw new Error('Required parameter serverId was null or undefined when calling deleteServer.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.configuration.basePath}/servers/${encodeURIComponent(String(serverId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serverId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getServer(serverId: string, observe?: 'body', reportProgress?: boolean): Observable<Server>;
    public getServer(serverId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Server>>;
    public getServer(serverId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Server>>;
    public getServer(serverId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (serverId === null || serverId === undefined) {
            throw new Error('Required parameter serverId was null or undefined when calling getServer.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Server>(`${this.configuration.basePath}/servers/${encodeURIComponent(String(serverId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get servers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getServers(observe?: 'body', reportProgress?: boolean): Observable<Array<ServerDetails>>;
    public getServers(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServerDetails>>>;
    public getServers(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServerDetails>>>;
    public getServers(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ServerDetails>>(`${this.configuration.basePath}/servers`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serverId 
     * @param server Server objects that needs to be updated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateServer(serverId: string, server: Server, observe?: 'body', reportProgress?: boolean): Observable<Server>;
    public updateServer(serverId: string, server: Server, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Server>>;
    public updateServer(serverId: string, server: Server, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Server>>;
    public updateServer(serverId: string, server: Server, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (serverId === null || serverId === undefined) {
            throw new Error('Required parameter serverId was null or undefined when calling updateServer.');
        }
        if (server === null || server === undefined) {
            throw new Error('Required parameter server was null or undefined when calling updateServer.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Server>(`${this.configuration.basePath}/servers/${encodeURIComponent(String(serverId))}`,
            server,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
